import { DPP_JOURNEY_ID_PATTERN, DPP_JOURNEY_STORAGE_KEY } from '@/data/dpp/constants';

const canUseStorage = () => typeof window !== 'undefined' && Boolean(window.sessionStorage);

export const isValidDppJourneyId = (value: unknown): value is string =>
	typeof value === 'string' && DPP_JOURNEY_ID_PATTERN.test(value);

export const readDppJourneyId = (): string | null => {
	if (!canUseStorage()) return null;
	try {
		const stored = sessionStorage.getItem(DPP_JOURNEY_STORAGE_KEY);
		return isValidDppJourneyId(stored) ? stored : null;
	} catch {
		return null;
	}
};

export const storeDppJourneyId = (journeyId: string): boolean => {
	if (!canUseStorage() || !isValidDppJourneyId(journeyId)) return false;
	try {
		sessionStorage.setItem(DPP_JOURNEY_STORAGE_KEY, journeyId);
		return true;
	} catch {
		return false;
	}
};
